export class MathHelper {
    
    /**
     * 
     * @param _amount 
     * @param _min 
     * @param _max 
     * @returns 
     */
    public static randomGenerator(_amount: number, _min: number, _max: number) {
      let uniques = new Set();
      
      while (uniques.size < _amount) {
        uniques.add(Math.floor(Math.random() * (_max - _min + 1)) + _min)
      }
      return Array.from(uniques)
    }

    /**
     * 
     * @param _container 
     * @param _mechanic 
     * @param _cName 
     */
    public static mutateEle(_container: HTMLElement, _mechanic: string, _cName: string) {
      switch (_mechanic) {
        case 'toggle-class':
          _container?.classList.toggle(_cName)
          break;
        case 'add-attribute':
          _container?.setAttribute(_cName, '')
          break;
        case 'toggle-attribute':
          _container?.toggleAttribute(_cName)
          break;
        case 'remove-attribute':
          _container?.removeAttribute(_cName)
          break;
        case 'add-class':
          _container?.classList.add(_cName)
          break;
        case 'remove-class':
          _container?.classList.remove(_cName)
          break;
      }
    }
}